import React from 'react';
import { Modal, Form, Button } from 'antd';
import EmailRecipients from 'components/global/Form/EmailRecipients';
import useVoucherSend from 'PDF/AttentionVoucher/useVoucherSend';

/**
 * Modal para enviar un comprobante de atención por email.
 * Archiva el PDF de forma inmutable en el backend (POST /comprobantes/:id/send).
 *
 * @param {{ open: boolean, onClose: () => void, voucher: object }} props
 */
function SendVoucherModal({ open, onClose, voucher }) {
  const [form] = Form.useForm();
  const { sendVoucher, loading } = useVoucherSend();

  const onFinish = async (values) => {
    try {
      await sendVoucher(voucher, { to: values.to, cc: values.cc });
      onClose?.();
    } catch {
      // error ya notificado por el hook; dejar el modal abierto para reintentar
    }
  };

  return (
    <Modal
      title={`Enviar comprobante N°${voucher?.id ?? ''}`}
      open={open}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ to: [voucher?.client_email].filter(Boolean), cc: [] }}
      >
        <EmailRecipients />
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Enviar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SendVoucherModal;
